export default __webpack_public_path__ + "static/images/cafd818a8c2d37803151f80a8cd4b12a.svg";